module.exports = __webpack_public_path__ + "static/media/2020logo0.263b2e16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Introduction/img/2020logo0.svg
// module id = 290
// module chunks = 0